<template>
  <el-container class="app-wrapper">
    <el-header height="58">
      <navbar />
    </el-header>
    <el-container class="main-container">
      <div v-if="!sideBar" @click="handleCloseClick" class="mask-layer"></div>
      <sidebar ref="sidebar" />
      <router-view :key="key" />
    </el-container>
  </el-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { getAuth } from '@/server/api/login';
export default {
  name: "Layout",
  props: {},
  components: {
    sidebar: () => import("@/components/layout/sidebar.vue"),
    navbar: () => import("@/components/layout/navbar.vue")
  },
  data () {
    return {
    }
  },
  // 计算属性
  computed: {
    ...mapState(['sideBar']),
    ...mapGetters(['userInfo']),
    key () {
      return this.$route.path
    },
  },
  // 创建后
  created () {
    if (localStorage.getItem('token')) {
      this.getAuthInfo();
    }
  },
  //挂载后
  mounted () {
  },
  // 方法
  methods: {
    // 获取用户信息
    async getAuthInfo () {
      const res = await getAuth();
      console.log(res, '=== res auth ===');
      if (res.code == 200 && Object.keys(res.data).length) {
        const { user = {}, menu = [], buttonArray = [] } = res.data;
        localStorage.setItem('user', JSON.stringify(user));
        this.$store.dispatch("setUser", user);
        localStorage.setItem('menu', JSON.stringify(menu));
        this.$store.dispatch("setMenu", menu);
        localStorage.setItem('permission', JSON.stringify(buttonArray));
        this.$store.dispatch("setPerms", buttonArray);
      }
    },
    // 小屏幕下点击遮罩层关闭菜单层
    handleCloseClick () {
      const sidebar = this.$refs.sidebar;
      if (sidebar) {
        sidebar.handleCloseClick();
      }
    },
  },
  // 组件销毁
  beforeDestroy () {
  },
  // 监听
  watch: {
  },
}
</script>
 
<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 1px;
}
.el-header {
  border-radius: 10px;
  background-color: rgb(68, 133, 244);
  box-shadow: 0px 1px 12.74px 0.26px rgba(8, 131, 246, 0.2);
  margin-bottom: 4px;
  height: 58px;
  padding: 7px 20px;
}
.main-container {
  height: calc(100vh - 64px);
}

.fixed-comment-inlet {
  position: fixed;
  right: 32px;
  bottom: 32px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e9e9eb;
  border-radius: 8px;
  width: 50px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  li {
    color: #333;
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    padding: 6px;
    cursor: pointer;
    overflow: hidden;
    &:nth-child(1) {
      background: #409eff;
      color: #fff;
      &:hover {
        background: #409eff;
        color: #fff;
      }
    }
    &:hover {
      background-color: #f4f4f5;
      color: #409eff;
    }
  }
}
</style>